import { useSelector } from "react-redux";
import QrCode from "../common/QrCode";
import useWakeLock from "../../hooks/useWakeLock";
import { selectCurrentSong, selectCurrentVerse, selectCurrentVerseIndex, selectHasSong, selectPreviousVerse, selectTranspose } from "../../selectors";
import { lastLines, sortedVerses, verseLabel, verseLines } from "../../lib/lyrics";
import { invitationLink, shortLink } from "../../lib/clipboard";
import { isLive, statusWord } from "./liveStatus";

/** The room screen: any browser joined to the session, read-only, large type, the code to join. */
const ProjectorPage = () => {
  const session = useSelector((state) => state.session);
  const song = useSelector(selectCurrentSong);
  const hasSong = useSelector(selectHasSong);
  const verse = useSelector(selectCurrentVerse);
  const index = useSelector(selectCurrentVerseIndex);
  const previous = useSelector(selectPreviousVerse);
  const showChords = useSelector((state) => state.preferences.showChords);
  const transpose = useSelector((state) => selectTranspose(state, song.Id));
  useWakeLock(true);

  const lines = verseLines(verse, transpose);
  const status = isLive(session) ? `Live${session.Listeners > 0 ? ` · ${session.Listeners} singing` : ""}` : statusWord(session);

  return (
    <div className="projector" data-screen-label="Projector">
      <div className="projector-head">
        <span className="projector-title">{song.Title}</span>
        <span className="live-status">
          <span className={`dot${isLive(session) ? "" : " dot-off"}`} aria-hidden="true" />
          <span>{status}</span>
        </span>
      </div>
      {previous && (
        <div className="tail" style={{ textAlign: "center", paddingTop: 8 }}>
          {lastLines(previous, 2).map((line, position) => (
            <div key={position} className="faded-line">
              {line}
            </div>
          ))}
        </div>
      )}
      <div className="projector-body">
        {lines.map((line, position) => (
          <div key={position} className="projector-line">
            {showChords && line.hasChords ? (
              <span className="lyric-line" style={{ justifyContent: "center" }}>
                {line.segments.map((segment, segmentIndex) => (
                  <span key={segmentIndex} className="seg">
                    {segment.chord != null && <span className="projector-chord">{segment.chord}</span>}
                    <span>{segment.text || " "}</span>
                  </span>
                ))}
              </span>
            ) : (
              line.text || " "
            )}
          </div>
        ))}
      </div>
      <div className="projector-foot">
        <span className="chip">{hasSong ? verseLabel(verse, index) : "Waiting for the host"}</span>
        <span className="projector-join">
          <span>
            <span className="kicker" style={{ display: "block" }}>
              Join · {shortLink(session.Code)}
            </span>
            <span className="qr-code" style={{ display: "block" }}>
              {session.Code}
            </span>
          </span>
          <QrCode value={invitationLink(session.Code)} size={200} className="qr-img qr-img-lg" />
        </span>
      </div>
      <span className="sr-only">{sortedVerses(song).length} sections</span>
    </div>
  );
};

export default ProjectorPage;
